import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

import {
  HeaderBox, Title, continueButtonStyles,
} from '@/pages/PreOnboarding/steps/ActivateSleepio/steps/AuthMethodSelection.styles';
import Button from '@/components/Button';

/**
 * "You're all set" — shown after a password saves.
 *
 * Two paths reach it: a member who was asked after verifying their address, and a
 * member who followed a reset link. Both see the same words, which is why this lives
 * in one place rather than being written out twice and left to drift.
 */
const PasswordSavedPanel: React.FC<{ onContinue: () => void }> = ({ onContinue }) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderBox>
        <Title variant="h2" color="textPrimary">
          {t('coverage.pre_onboarding.sleepio.activation.password_saved.title')}
        </Title>
        <Typography color="textPrimary">
          {t('coverage.pre_onboarding.sleepio.activation.password_saved.sub_title')}
        </Typography>
      </HeaderBox>

      <Button
        variant="contained"
        data-testid="continue-to-sleepio-button"
        type="button"
        fullWidth
        color="primary"
        rounded
        style={continueButtonStyles}
        onClick={onContinue}
      >
        {t('coverage.pre_onboarding.sleepio.activation.password_saved.continue')}
      </Button>
    </>
  );
};

export default PasswordSavedPanel;
